import { apiPost } from '@/features/shared/utils/dataFetching'
import { type GECXTokenResponse } from '@/features/shop/services/ShoppingAgent/types'
import { type StoreParams } from '@/features/shared/utils/dataFetching/storeParams'

type FetchGECXTokenParams = {
  sessionId: string | undefined
  storeParams: StoreParams
}

export function fetchGECXToken({ sessionId, storeParams }: FetchGECXTokenParams) {
  return apiPost<GECXTokenResponse>({
    config: {
      url: 'gecx/v1/tokens/',
      data: sessionId ? { sessionId } : undefined,
    },
    options: { storeParams },
    fetcherName: 'fetchGECXToken',
  })
}
